import React from 'react';
import { Button } from '../ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-50" data-id="element-102">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-103"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="max-w-4xl mx-auto text-center" data-id="element-105">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight mb-8 fade-in-up delay-100 leading-[1.1]" data-id="element-106">
            Turn Your Audience's Attention Into{' '}
            <span className="text-emerald-600" data-id="element-107">Consistent Sales.</span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 mb-10 max-w-2xl mx-auto fade-in-up delay-200 leading-relaxed" data-id="element-108">
            I help coaches and course creators fix their messaging, optimize
            their funnels, and scale without sounding like a desperate marketer.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up delay-300" data-id="element-109">
            <Button size="lg" withArrow onClick={() => {
            if (typeof window !== 'undefined' && (window as any).Calendly) {
              ;
              (window as any).Calendly.initPopupWidget({
                url: 'https://calendly.com/okechcopy/new-meeting'
              });
            }
          }} data-id="element-110">
              Book a Strategy Call
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('approach')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-111">
              See How I Work
            </Button>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-sm text-slate-500 fade-in-up delay-300" data-id="element-112">
            <div className="flex items-center" data-id="element-113">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-114" />
              <span data-id="element-115">Data-Driven Approach</span>
            </div>
            <div className="flex items-center" data-id="element-116">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-117" />
              <span data-id="element-118">Conversion Focused</span>
            </div>
            <div className="flex items-center" data-id="element-119">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-120" />
              <span data-id="element-121">Brand Voice Retention</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}